module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3QxXF"))).then(() => parcelRequire('hEqeo'));